module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$permission.has("bills.balance")) ? _c('div', {
    staticClass: "balance-bar"
  }, [(_vm.balance.from && _vm.balance.lastTotal) ? [_c('div', {
    staticClass: "title"
  }, [_vm._v("起始日期")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.$formatters.date.to_date(_vm.balance.from)))]), _c('div', {
    staticClass: "title"
  }, [_vm._v("起始结余")]), _c('div', {
    staticClass: "value",
    class: {
      negative: _vm.balance.lastTotal < 0
    }
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.balance.lastTotal)))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("|")])] : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_vm._v("截至日期")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.$formatters.date.to_date(_vm.balance.to)))]), _c('div', {
    staticClass: "title"
  }, [_vm._v("收入")]), _c('div', {
    staticClass: "value",
    class: {
      negative: _vm.balance.income < 0
    }
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.balance.income)))]), _c('div', {
    staticClass: "title"
  }, [_vm._v("支出")]), _c('div', {
    staticClass: "value",
    class: {
      negative: _vm.balance.outcome > 0
    }
  }, [_vm._v(_vm._s(_vm.$formatters.money(-_vm.balance.outcome)))]), (_vm.balance.from && _vm.balance.lastTotal) ? [_c('div', {
    staticClass: "title"
  }, [_vm._v("合计")]), _c('div', {
    staticClass: "value",
    class: {
      negative: _vm.balance.total < 0
    }
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.balance.total)))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("|")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("结余")]), _c('div', {
    staticClass: "value",
    class: {
      negative: _vm.balance.total + _vm.balance.lastTotal < 0
    }
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.balance.total + _vm.balance.lastTotal)))])] : [_c('div', {
    staticClass: "title"
  }, [_vm._v("结余")]), _c('div', {
    staticClass: "value",
    class: {
      negative: _vm.balance.total < 0
    }
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.balance.total)))])]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10f4398e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/BalanceBar.vue
// module id = 335
// module chunks = 0